export default __webpack_public_path__ + "static/media/logo_rallybio.6dd08574.svg";